$( document ).ready(function() {
  // SWIPER - Handle multiple products
  document.querySelectorAll('.product-swiper').forEach(function(swiperElement) {
    const productSwiper = new Swiper(swiperElement, {
      loop: true,
      speed: 300,
      breakpoints: {
        820: {
          speed: 1,
        }
      },
      spaceBetween: 10,
      pagination: {
        el: swiperElement.querySelector('.swiper-pagination'),
        type: "fraction",
      },
      navigation: {
        nextEl: swiperElement.querySelector('.button-next'),
        prevEl: swiperElement.querySelector('.button-prev'),
      }
    });

    $(document).off('click', '.swiper-slide-active .mobile-button-prev').on('click', '.swiper-slide-active .mobile-button-prev', function(event) {
      event.preventDefault();
      var swiperInstance = $(this).closest('.product-swiper')[0].swiper;
      swiperInstance.slidePrev();
    });

    $(document).off('click', '.swiper-slide-active .mobile-button-next').on('click', '.swiper-slide-active .mobile-button-next', function(event) {
      event.preventDefault();
      var swiperInstance = $(this).closest('.product-swiper')[0].swiper;
      swiperInstance.slideNext();
    });

    // Get thumbnails for this specific product
    const productContainer = swiperElement.closest('.product-container') || swiperElement.parentElement;
    const thumbnails = productContainer.querySelectorAll('.product-thumbnail');

    thumbnails.forEach(function(thumbnail, index) {
      thumbnail.addEventListener('click', function() {
        productSwiper.slideToLoop(index);
        thumbnails.forEach(function(thumb) {
          thumb.classList.remove('active');
        });
        thumbnail.classList.add('active');
        
        // Scroll thumbnail to left position
        const thumbnailContainer = thumbnail.parentElement;
        if (thumbnailContainer) {
          const containerRect = thumbnailContainer.getBoundingClientRect();
          const thumbnailRect = thumbnail.getBoundingClientRect();
          const scrollAmount = thumbnailRect.left - containerRect.left + thumbnailContainer.scrollLeft;
          
          thumbnailContainer.scrollTo({
            left: scrollAmount,
            behavior: 'smooth'
          });
        }
      });
    });

    productSwiper.on('slideChange', function() {
      const realIndex = productSwiper.realIndex;
      thumbnails.forEach(function(thumbnail, index) {
        if (index === realIndex) {
          thumbnail.classList.add('active');
          
          // Scroll thumbnail to left position
          const thumbnailContainer = thumbnail.parentElement;
          if (thumbnailContainer) {
            const containerRect = thumbnailContainer.getBoundingClientRect();
            const thumbnailRect = thumbnail.getBoundingClientRect();
            const scrollAmount = thumbnailRect.left - containerRect.left + thumbnailContainer.scrollLeft;
            
            thumbnailContainer.scrollTo({
              left: scrollAmount,
              behavior: 'smooth'
            });
          }
        } else {
          thumbnail.classList.remove('active');
        }
      });
    });
  });

  // DETAILS - Handle multiple products: hover trigger on desktop (≥821px), click on mobile
  var detailsDesktopHover = window.matchMedia('(min-width: 821px)');

  document.querySelectorAll('.details-trigger').forEach(function(detailsTrigger) {
    const productContainer = detailsTrigger.closest('.product-container') || detailsTrigger.parentElement;
    const detailsContainer = productContainer.querySelector('.product-details-container');
    const triggerIcon = detailsTrigger.querySelector('.details-icon');
    const productDetails = productContainer.querySelector('.product-details');

    function setDetailsIcon(show) {
      if (triggerIcon) triggerIcon.textContent = show ? '−' : '+';
    }

    if (productDetails) {
      detailsTrigger.addEventListener('mouseenter', function() {
        if (detailsDesktopHover.matches) {
          productDetails.classList.add('show');
          setDetailsIcon(true);
        }
      });
      detailsContainer.addEventListener('mouseleave', function() {
        if (detailsDesktopHover.matches) {
          productDetails.classList.remove('show');
          setDetailsIcon(false);
        }
      });

      detailsTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        if (detailsDesktopHover.matches) return;
        productDetails.classList.toggle('show');
        setDetailsIcon(productDetails.classList.contains('show'));
      });
    }
  });
});